import { Box, Divider, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../common/FormikControl";
import FormLabel from "../../styled/FormLabel";
import { addMoreEvents, selectAllSlots, selectSlotLocation, selectSlotMonth } from "../../../slices/slotManagement";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useState } from "react";
import { selectAllLocation } from "../../../slices/common";
const daysValues = {
    Mon: "",
    Tue: "",
    Wed: "",
    Thu: "",
    Fri: "",
    Sat: "",
    Sun: "",
}
// Checkbox options
const slotOptions = [
    { value: '1', label: '1 Slot' },
    { value: '2', label: '2 Slot' },
    { value: '3', label: '3 Slot' },
    { value: '4', label: '4 Slot' },
    { value: '5', label: '5 Slot' },
    { value: '6', label: '6 Slot' },
    { value: '7', label: '7 Slot' },
];


const SingleSlotsForm = ({ onClose }) => {
    const dispatch = useDispatch()
    const allLocation = useSelector(selectAllLocation)
    const allSlots = useSelector(selectAllSlots)
    const location = useSelector(selectSlotLocation)
    const slotMonth = useSelector(selectSlotMonth)
    const [slotInitialValues, setSlotInitialValues] = useState(daysValues)

    const initialValues = { ...slotInitialValues, location: location ?? "" }


    // Function to get all days in a month
    function getDaysInMonth(year, month) {
        const date = new Date(year, month, 1);
        const days = [];
        while (date.getMonth() === month) {
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        return days;
    }

    // Function to map days of the week to dates in the month
    function mapDaysToDates(year, month, data) {
        const daysInMonth = getDaysInMonth(year, month);
        const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]; // Map day numbers to day names
        const result = {};

        daysInMonth.forEach(day => {
            const dayOfWeekNumber = day.getDay(); // Get day of the week as a number (0-6)
            const dayOfWeek = dayNames[dayOfWeekNumber]; // Get day name (e.g., "Mon", "Tue")
            if (data[dayOfWeek] !== "") {
                result[moment(day).format("D-MMM-yyyy")] = data[dayOfWeek];
            }
        });

        return result;
    }

    const handleSubmit = async (values) => {
        // Step 1: Extract the month and year from slotMonth
        const slotDate = new Date(slotMonth);
        const slotMonthYear = slotMonth.getMonth(); // Get month (0-based index, e.g., July = 6)
        const slotYear = slotDate.getFullYear(); // Get year
        const filteredData = mapDaysToDates(slotYear, slotMonthYear, values);
        const slots = Object.entries(filteredData).flatMap(([key, value]) => {
            // Initialize a counter to track the slot index for the same day
            let dayIndex = 0;
            return Array.from({ length: value }, () => {
                // Increment the dayIndex for each new slot
                dayIndex++;
                return {
                    title: `Slot-${dayIndex}`, // Add the index to the title
                    start: moment(new Date(key)).format("YYYY-MM-DDTHH:mm:ss"),
                    end: moment(new Date(key)).format("YYYY-MM-DDTHH:mm:ss"),
                    type: "Available",
                };
            });
        });
                
        await dispatch(addMoreEvents([...allSlots, ...slots]))
        setSlotInitialValues(values)
        onClose()
    };
    
    const formik = useFormik({
        initialValues,
        onSubmit: handleSubmit
    })

    const formOptions = [
        {
            type: 'select',
            name: 'location',
            required: true,
            placeholder: 'Select Any Location',
            options: allLocation?.items?.map(op => { return { value: op.id, label: op.name } }),
            disabled: true,
        },
        {
            label: 'Monday',
            type: 'select',
            name: 'Mon',
            required: true,
            options: slotOptions,
        },
        {
            label: 'Tuesday',
            type: 'select',
            name: 'Tue',
            required: true,
            options: slotOptions,
        },
        {
            label: 'Wednesday',
            type: 'select',
            name: 'Wed',
            required: true,
            options: slotOptions,
        },
        {
            label: 'Thursday',
            type: 'select',
            name: 'Thu',
            required: true,
            options: slotOptions,
        },
        {
            label: 'Friday',
            type: 'select',
            name: 'Fri',
            required: true,
            options: slotOptions,
        },
        {
            label: 'Saturday',
            type: 'select',
            name: 'Sat',
            required: true,
            options: slotOptions,
        },
        {
            label: 'Sunday',
            type: 'select',
            name: 'Sun',
            required: true,
            options: slotOptions,
        },
    ];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        key == 0 ?
                            <Grid key={key} item xs={12}>
                                <FormikControl formik={formik} {...props} />
                                {key == 0 &&
                                    <Divider className="mt-3" />}
                            </Grid> :
                            <Grid key={key} item xs={12}>
                                <Box className='flex'>
                                    <FormLabel className="w-50 mb-0 mt-2" shrink>{props.label}</FormLabel>
                                    <FormikControl formik={formik}  {...{ ...props, label: '' }} />
                                </Box>
                            </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LoadingButton fullWidth type="submit" variant="contained">Submit</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default SingleSlotsForm;